import React from 'react';
import { Toaster } from 'react-hot-toast';

import MainContent from '../../components/mainContent/MainContent';
import { Outlet } from 'react-router-dom';
import InstitucionAll from './components/InstitucionAll';

export default function Role() {
  return (
    <>
      <MainContent
        titulo='Administración de Instituciones'
        component={<InstitucionAll />}
        tableMaxWidth
      />
      
      <Outlet />
    </>
  );
}